<template>
  <g :id="crown.wrapperId">
    <v-touch tag="g" :id="crown.id" class="crown" @tap="interpretCrown()">
      <linearGradient id="SVGID_A-04_15_" gradientUnits="userSpaceOnUse" x1="142.6911" y1="501.465" x2="135.4839" y2="488.9819" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#E6E7E7"/>
        <stop  offset="1" style="stop-color:#929497"/>
      </linearGradient>
      <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M139.0863,118.3417c0,0,1.4551-2.1062,1.4551-8.3206s-1.4551-8.3237-1.4551-8.3237"/>
      <linearGradient id="SVGID_A-04_16_" gradientUnits="userSpaceOnUse" x1="140.2831" y1="504.0014" x2="130.0612" y2="486.2968" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#E6E7E7"/>
        <stop  offset="1" style="stop-color:#929497"/>
      </linearGradient>
      <foreignObject x="145.5" y="106" width="8px" height="8px" overflow="visible">
        <div class="crownText" style="pointer-events: none; user-select: none;" v-text="crownText"></div>
      </foreignObject>
      <!--<text class="crownText" x="145.5" y="110" text-anchor="middle" alignment-baseline="middle" style="pointer-events: none; user-select: none;"><tspan v-text="crownText"></tspan></text>-->
      <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="138.9246,119.3547
      139.0866,118.9567 139.0866,101.0567 138.9246,100.6617 138.3126,100.0857 131.8046,100.0857 131.1946,101.6977 131.1866,118.3417
      131.8246,119.9287 138.3226,119.9287 	"/>
      <linearGradient id="SVGID_A-04_17_" gradientUnits="userSpaceOnUse" x1="140.165" y1="486.3874" x2="129.9627" y2="504.0584" gradientTransform="matrix(1 0 0 1 0 -385.2046)">
        <stop  offset="0" style="stop-color:#E6E7E7"/>
        <stop  offset="1" style="stop-color:#929497"/>
      </linearGradient>
      <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="131.8136,101.6977
      131.1946,101.6977 131.8046,100.1087 138.3046,100.1087 138.9136,101.6977 138.3126,101.6977 138.9256,103.0507
      138.3256,103.5177 138.9346,105.0277 138.3256,105.8857 138.9066,107.4407 138.3256,108.6267 138.9346,109.9947
      138.3256,111.4117 138.9416,112.5967 138.3026,114.1507 138.9116,115.0097 138.3026,116.5227 138.9216,116.9877
      138.3156,118.3417 138.9316,118.3417 138.3226,119.9287 131.8246,119.9287 131.2146,118.3417 131.8156,118.3417
      131.1996,116.9877 131.8026,116.5227 131.1936,115.0097 131.8026,114.1507 131.2226,112.5967 131.8026,111.4117
      131.2246,109.9947 131.8166,108.6267 131.1866,107.4407 131.8246,105.8857 131.2146,105.0277 131.8246,103.5177
      131.2076,103.0507 		"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8133" y1="101.6974" x2="138.3122" y2="101.6974"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8244" y1="103.5177" x2="138.3252" y2="103.5177"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8244" y1="105.8856" x2="138.3252" y2="105.8856"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8166" y1="108.6266" x2="138.3252" y2="108.6266"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="111.4118" x2="138.3252" y2="111.4118"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="114.1508" x2="138.3031" y2="114.1508"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8029" y1="116.5226" x2="138.3031" y2="116.5226"/>
      <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8159" y1="118.3417" x2="138.3161" y2="118.3417"/>
    </v-touch>

    <g :id="arrowsGroupName">
      <v-touch tag="g"
               v-show="cOption && cOption.type"
               :id="cArrow.id"
               class="arrow"
               @tap="cTapMethod()"
               @press="cPressMethod()"
               @pressup="cPressupMethod()"
               @pan="cPressupMethod()"
               @pancancel="cPressupMethod()">
        <circle class="highlight" r="6.3048" cx="6.3048" cy="6.3048" transform="matrix(1,0,0,1,129.6163,85.14518)" fill="#edebb9" stroke="none" opacity="0" style="mix-blend-mode: multiply;"></circle>
        <path class="arrow-line" fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M137.6404,94.8417
        c-0.5838,0.3434-1.2641,0.5403-1.9904,0.5403c-2.1716,0-3.932-1.7604-3.932-3.932c0-2.1716,1.7604-3.932,3.932-3.932
        c2.1716,0,3.932,1.7604,3.932,3.932"/>
        <polyline class="arrow-line" fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="140.1244,89.3858 139.582,91.45
        138.0707,89.9533"/>
      </v-touch>
      <v-touch tag="g"
               v-show="ccOption && ccOption.type"
               :id="ccArrow.id"
               class="arrow"
               @tap="ccTapMethod()"
               @press="ccPressMethod()"
               @pressup="ccPressupMethod()"
               @pan="ccPressupMethod()"
               @pancancel="ccPressupMethod()">
        <circle class="highlight" r="6.3048" cx="6.3048" cy="6.3048" transform="matrix(1,0,0,1,129.0739,122.64518)" fill="#edebb9" stroke="none" opacity="0" style="mix-blend-mode: multiply;"></circle>
        <path class="arrow-line" fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M133.6596,132.3417
        c0.5838,0.3434,1.2641,0.5403,1.9904,0.5403c2.1716,0,3.932-1.7604,3.932-3.932c0-2.1716-1.7604-3.932-3.932-3.932
        c-2.1716,0-3.932,1.7604-3.932,3.932"/>
        <polyline class="arrow-line" fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="131.1756,126.8858 131.718,128.95
        133.2293,127.4533"/>
      </v-touch>
    </g>
  </g>
</template>

<script>
import {
  each, filter, has, includes, without, kebabCase,
} from 'lodash';

export default {
  name: 'sdCrown',
  props: ['crownData', 'watchData', 'tutorialModeData'],
  data() {
    return {
      cTimeout: undefined,
      cContinueEvent: false,
      ccTimeout: undefined,
      ccContinueEvent: false,
    };
  },
  computed: {
    crown() {
      if (this.crownData) return this.crownData;
    },
    cArrow() {
      if (this.crown.arrowElements) return this.crown.arrowElements.find(a => a.direction === 1);
    },
    ccArrow() {
      if (this.crown.arrowElements) return this.crown.arrowElements.find(a => a.direction === -1);
    },
    wristwatch() {
      if (this.watchData) return this.watchData;
    },
    tutorialMode() {
      if (this.tutorialModeData) return this.tutorialModeData;
    },
    arrowsGroupName() {
      if (this.wristwatch) return this.name('Arrows');
    },
    crownText() {
      let numeral = '';
      for (let i = 0; i < this.crown.value + 1; i++) {
        numeral = `${numeral}I`;
      }
      return numeral;
    },
    crownMethod() {
      if (this.crown && this.crown.functions && this.crown.functions.length > 0) {
        return this.crown.functions.find(cf => cf.position === this.crown.value);
      }
    },
    cOption() {
      if (this.crownMethod) {
        return this.crownMethod.options.find(opt => includes([0, 1], opt.direction));
      }
    },
    ccOption() {
      if (this.crownMethod) {
        return this.crownMethod.options.find(opt => includes([0, -1], opt.direction));
      }
    },
    cTapMethod() {
      if (this.cOption) {
        return () => {
          this.$emit(kebabCase(this.cOption.type), this.cArrow);
          this.cArrow.hasEvent = true;
          if (this.tutorialMode) {
            this.$emit('evaluate-component', this.wristwatch);
          }
        };
      }
    },
    ccTapMethod() {
      if (this.ccOption) {
        return () => {
          this.$emit(kebabCase(this.ccOption.type), this.ccArrow);
          this.ccArrow.hasEvent = true;
          if (this.tutorialMode) {
            this.$emit('evaluate-component', this.wristwatch);
          }
        };
      }
    },
    cPressMethod() {
      // Assume press threshold has been passed
      if (this.cOption.direction === 0) {
        return () => {
          this.cTimeout = setTimeout(() => {
            this.cContinueEvent = true;
            const quick = setInterval(() => {
              this.cTapMethod();
              if (!this.cContinueEvent) clearInterval(quick);
            }, 16);
          }, 0);
        };
      }
      return () => this.cTapMethod();
    },
    cPressupMethod() {
      return () => {
        if (this.tutorialMode) {
          this.$emit('evaluate-component', this.wristwatch);
        }
        this.cContinueEvent = false;
        clearTimeout(this.cTimeout);
      };
    },
    ccPressMethod() {
      // Assume press threshold has been passed
      if (this.ccOption.direction === 0) {
        return () => {
          this.ccTimeout = setTimeout(() => {
            this.ccContinueEvent = true;
            const quick = setInterval(() => {
              this.ccTapMethod();
              if (!this.ccContinueEvent) clearInterval(quick);
            }, 16);
          }, 0);
        };
      }
      return () => this.ccTapMethod();
    },
    ccPressupMethod() {
      return () => {
        if (this.tutorialMode) {
          this.$emit('evaluate-component', this.wristwatch);
        }
        this.ccContinueEvent = false;
        clearTimeout(this.ccTimeout);
      };
    },
  },
  methods: {
    name(prefix) {
      return `${prefix}_${this.wristwatch.slug}`;
    },
    interpretCrown(init = false) {
      const previousCrownValue = this.crown.value;
      // Cycle through crown positions
      if (!init) this.crown.value = (this.crown.value + 1) % this.crown.functions.length;
      this.positionCrown();
      const as = [{ c: this.cArrow, opt: this.cOption }, { c: this.ccArrow, opt: this.ccOption }];
      each(as, a => this.$emit('toggle-component', { component: a.c, condition: a.opt }), this);
      // Check if movement runs at current crown position
      const prevPosition = this.crown.functions.find(func => func.position === previousCrownValue);
      const currentPosition = this.crown.functions.find(func => func.position === this.crown.value);
      this.wristwatch.isRunning = currentPosition.running;
      if (this.wristwatch.isRunning && !prevPosition.running) {
        this.$emit('update-time');
      } else if (this.wristwatch.isRunning && !this.wristwatch.timeout) {
        this.$emit('update-time');
      }
      // End counter reset;
      // Reset pushers to normal operation
      if (this.wristwatch.chrono
          && this.wristwatch.counterReset
          && this.wristwatch.counterReset.inProgress
          && prevPosition.position === 2
          && currentPosition.position === 0) {
        this.$emit('debounce-handset-highlight', { components: [this.wristwatch.components.second, this.wristwatch.components.chronoH, this.wristwatch.components.chronoM], color: '#C0AD00' });
        this.wristwatch.counterReset.value = 0;
        this.wristwatch.counterReset.inProgress = false;
        const pushers = [this.wristwatch.components.pusherA, this.wristwatch.components.pusherB];
        this.$emit('clear-events-from-components', { components: pushers });
      }
      if (this.tutorialMode) this.$emit('evaluate-component', this.wristwatch);
    },
    positionCrown() {
      this.crown.value !== 0
        ? this.crown.wrapperElement.animate(330).move(this.crown.value * 4, 0)
        : this.crown.wrapperElement.animate(240).move(0, 0); this.$emit('toggle-components', { components: this.crown.arrowElements, condition: false });
      this.$emit('highlight-circle', { self: this.crown, condition: this.crown.value !== 0 });
    },
    updateArrowElementFunctions() {
      // If corresponding function(s) @ current position, display arrow(s);
      // Update arrow elements' functions
      if (this.crownMethod.options.length > 0) {
        this.$emit('clear-events-from-components', { components: this.crown.arrowElements });
        // List of unused arrows;
        // if an arrow is used for a function,
        // remove it from list;
        // hide any remaining unused arrows
        let unusedArrows = this.crown.arrowElements;
        each(this.crownMethod.options, (opt) => {
          if (has(opt, 'type')) {
            const handset = filter(this.wristwatch.components, (component, componentName) => includes(opt.highlight, componentName));
            if (opt.type === 'setTime') {
              // Set event for both arrows
              each(this.crown.arrowElements, (arrow) => {
                unusedArrows = without(unusedArrows, arrow);
                this.$emit('set-component-event', {
                  component: arrow, funcName: opt.type, canHold: true, handset: handset.length > 0 ? handset : false,
                });
                this.$emit('toggle-component', { component: arrow, condition: true });
              }, this);
            } else if (opt.type === 'resetCounters') {
              // Do nothing
            } else {
              // Set the arrow's event
              const arrow = this.crown.arrowElements.find(arrow => arrow.direction === opt.direction);
              unusedArrows = without(unusedArrows, arrow);
              this.$emit('set-component-event', {
                component: arrow, funcName: opt.type, canHold: false, handset: handset.length > 0 ? handset : false,
              });
              this.$emit('toggle-component', { component: arrow, condition: true });
            }
            this.$emit('toggle-components', { components: unusedArrows, condition: false });
          }
        }, this);
      } else {
        // No options available; hide arrows
        this.$emit('toggle-components', { components: this.crown.arrowElements, condition: false });
      }
    },
  },
  mounted() {
    this.$emit('initialize-component', { component: this.crown, element: this.$el });
    this.interpretCrown(true);
  },
  beforeDestroy() {
    clearTimeout(this.wristwatch.timeout);
    this.wristwatch.timeout = undefined;
  }
};
</script>

<style lang="scss" scoped>
  .crown {
    // TODO: Other attrs needed here to disable ugly highlighting?
    outline: none;
  }
  .arrow {
    display: block;
    position: relative;
  }
  .crownText {
    //display: block;
    //position: relative;
    font: 500 8px/1 futura-pt, 'futura-pt', sans-serif;
    //transform: translate(-0.75ch, -50%);
  }
  .display-only .crownText {
    display: none;
  }
</style>
